import React from 'react';

export default function ReadingBlock({ text, questions, answers, onAnswer }) {
  return (
    <div className="space-y-6">
      <div className="bg-blue-50 p-6 rounded-lg border border-blue-200">
        <h3 className="font-semibold text-lg mb-3 text-blue-900">Tekst do czytania</h3>
        <p className="text-gray-800 leading-relaxed whitespace-pre-line">{text}</p>
      </div>
      
      <div className="space-y-4">
        {questions.map((question, index) => (
          <div key={question.id} className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
            <p className="font-medium text-gray-900 mb-3">
              {index + 1}. {question.question}
            </p>
            <div className="space-y-2">
              {question.options.map((option, optIndex) => (
                <label
                  key={optIndex}
                  className="flex items-center p-3 rounded-lg border border-gray-300 hover:bg-blue-50 cursor-pointer transition-colors"
                >
                  <input
                    type="radio"
                    name={question.id}
                    value={option}
                    checked={answers[question.id] === option}
                    onChange={(e) => onAnswer(question.id, e.target.value)}
                    className="mr-3 h-4 w-4 text-blue-600"
                  />
                  <span className="text-gray-700">{option}</span>
                </label>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
